import { MDBAlert, MDBBtn, MDBIcon, MDBModalFooter } from "mdb-react-ui-kit";
import { forwardRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { deleteRole } from "../../../apiclients/streamsapi_bridge";

export const DeleteRole = forwardRef((props, ref) => {
  const { t, i18n } = useTranslation();
  const [internalError, setInternalError] = useState(false);

  async function removeThisRole() {
    try {
      setInternalError(false);
      let delRoleRes = await deleteRole(JSON.parse(sessionStorage.getItem("admin_session")).siteid, props.roleId);
      let delInfo = await delRoleRes.json();
      if (delRoleRes.status == 200) {
        if (delInfo.status == 'success') {
          localStorage.setItem("s_message", delInfo.message);
        } else {
          localStorage.setItem("f_message", delInfo.message);
        }
      } else if (delRoleRes.status == 400) {
        localStorage.setItem("f_message", delInfo?.message?.errors?.[0]?.message ?? delInfo?.message);
      } else if (delRoleRes.status == 500) {
        setInternalError(true);
      }
      window.location.href = "/permissionrolessection";
      props.onClose();
    } catch (error) {
      console.log(`Unable to process Request :Internal server Error:!`);
      setInternalError(true);
    }
  }


  return (
    <>
      {internalError && (<MDBAlert
        open
        className="alert-center"
        color="danger"
        autohide
        position="bottom-right"
        delay={5000}
      >Internal Server Error</MDBAlert>)}

      <div className="d-flex align-items-center bg-danger bg-opacity-25 p-3  rounded-3 square border border-2 border-danger">
        <MDBIcon fas icon="ban" className="me-3" size="lg" color="danger" />
        <span>{t("RemoveAdminRoletxt")}</span>
      </div>

      <div style={{ display: "none" }}>
        <button ref={ref} onClick={(e) => removeThisRole()}>
          {t("remove")}</button>
      </div>

      {/* <MDBModalFooter>
        <MDBBtn color="secondary" onClick={props.onClose}>
          {t("close")}
        </MDBBtn>
        <MDBBtn onClick={(e) => removeThisRole()}>{t("remove")}</MDBBtn>
      </MDBModalFooter> */}
    </>
  );
});